import { getSession } from "./auth";
import { BenutzerTyp } from "./user-types";

export function isMobileDevice(): boolean {
  // Monteure (Rolle 6) bekommen immer das Desktop-Menü, egal von welchem Gerät
  // (ihre Laptops werden sonst als mobiles Gerät erkannt).
  if (Number(getSession()?.benutzerTyp) === BenutzerTyp.Monteur) return false;

  return window.matchMedia("(pointer: coarse)").matches ||
    /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

// Getter statt fester Wert: nach Login/Logout ändert sich die Rolle,
// ohne dass die Seite neu geladen wird.
export const DEVICE = {
  get isMobile(): boolean {
    return isMobileDevice();
  }
}
